/*! fw-store-finder.js — the count and "find the one nearest you" (Lance 2026-10-31: "we're in however many locations we're in, it
 * needs to be stated. And then you can say, find the one nearest you"). No dependencies. Slider-Page RULES "Decided — 2026-10-31 …
 * one integrated stores section".
 *   FWFinder.mount(el, { mode: 'dark' | 'light', rows: function () { return [{ n, c, s, la, lo, si }] }, hot: function (si, on) {},
 *                        all: '/pages/stores' })
 * The count ("Fragile What? is in N stores in M states") is worked out from the rows, never typed. Nearest: the shopper's location
 * (the browser asks them) or a typed ZIP / "City, ST" / state → the 3 nearest stores with distance. Everything is worked out in the
 * browser; the location is never sent anywhere. Only stores with a real map position are ranked (a store without one is still on the
 * stores page). A ZIP: a store with that ZIP, else the store with the nearest ZIP in the same 3-digit area, else that ZIP's state
 * (no ZIP table is shipped). A state on its own lists that state's stores, nearest its middle first.
 */
(function () {
  'use strict';
  var ST = { AL: [32.8, -86.8], AK: [64.0, -150.0], AZ: [34.3, -111.7], AR: [34.9, -92.4], CA: [37.2, -119.5], CO: [39.0, -105.5],
    CT: [41.6, -72.7], DE: [39.0, -75.5], DC: [38.9, -77.0], FL: [28.6, -82.4], GA: [32.7, -83.4], HI: [20.8, -156.3], ID: [44.4, -114.6],
    IL: [40.0, -89.2], IN: [39.9, -86.3], IA: [42.1, -93.5], KS: [38.5, -98.4], KY: [37.5, -85.3], LA: [31.1, -92.0], ME: [45.4, -69.2],
    MD: [39.0, -76.8], MA: [42.3, -71.8], MI: [44.3, -85.4], MN: [46.3, -94.3], MS: [32.7, -89.7], MO: [38.4, -92.5], MT: [47.0, -109.6],
    NE: [41.5, -99.8], NV: [39.3, -116.6], NH: [43.7, -71.6], NJ: [40.2, -74.7], NM: [34.4, -106.1], NY: [42.9, -75.5], NC: [35.6, -79.4],
    ND: [47.5, -100.5], OH: [40.3, -82.8], OK: [35.6, -97.5], OR: [43.9, -120.6], PA: [40.9, -77.8], RI: [41.7, -71.5], SC: [33.9, -80.9],
    SD: [44.4, -100.2], TN: [35.9, -86.4], TX: [31.5, -99.3], UT: [39.3, -111.7], VT: [44.1, -72.7], VA: [37.5, -78.8], WA: [47.4, -120.5],
    WV: [38.6, -80.6], WI: [44.6, -89.9], WY: [43.0, -107.6], PR: [18.2, -66.5] };
  var NAME = { AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California', CO: 'Colorado', CT: 'Connecticut',
    DE: 'Delaware', DC: 'Washington, D.C.', FL: 'Florida', GA: 'Georgia', HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana',
    IA: 'Iowa', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine', MD: 'Maryland', MA: 'Massachusetts', MI: 'Michigan',
    MN: 'Minnesota', MS: 'Mississippi', MO: 'Missouri', MT: 'Montana', NE: 'Nebraska', NV: 'Nevada', NH: 'New Hampshire',
    NJ: 'New Jersey', NM: 'New Mexico', NY: 'New York', NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio', OK: 'Oklahoma',
    OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina', SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas',
    UT: 'Utah', VT: 'Vermont', VA: 'Virginia', WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming', PR: 'Puerto Rico' };
  // the first three digits of a ZIP → its state (USPS prefix ranges)
  var Z3 = [[5, 5, 'NY'], [6, 9, 'PR'], [10, 27, 'MA'], [28, 29, 'RI'], [30, 38, 'NH'], [39, 49, 'ME'], [50, 59, 'VT'], [60, 69, 'CT'],
    [70, 89, 'NJ'], [100, 149, 'NY'], [150, 196, 'PA'], [197, 199, 'DE'], [200, 200, 'DC'], [201, 201, 'VA'], [202, 205, 'DC'],
    [206, 219, 'MD'], [220, 246, 'VA'], [247, 268, 'WV'], [270, 289, 'NC'], [290, 299, 'SC'], [300, 319, 'GA'], [320, 349, 'FL'],
    [350, 369, 'AL'], [370, 385, 'TN'], [386, 397, 'MS'], [398, 399, 'GA'], [400, 427, 'KY'], [430, 459, 'OH'], [460, 479, 'IN'],
    [480, 499, 'MI'], [500, 528, 'IA'], [530, 549, 'WI'], [550, 567, 'MN'], [569, 569, 'DC'], [570, 577, 'SD'], [580, 588, 'ND'],
    [590, 599, 'MT'], [600, 629, 'IL'], [630, 658, 'MO'], [660, 679, 'KS'], [680, 693, 'NE'], [700, 714, 'LA'], [716, 729, 'AR'],
    [730, 732, 'OK'], [733, 733, 'TX'], [734, 749, 'OK'], [750, 799, 'TX'], [800, 816, 'CO'], [820, 831, 'WY'], [832, 838, 'ID'],
    [840, 847, 'UT'], [850, 865, 'AZ'], [870, 884, 'NM'], [885, 885, 'TX'], [889, 898, 'NV'], [900, 961, 'CA'], [967, 968, 'HI'],
    [970, 979, 'OR'], [980, 994, 'WA'], [995, 999, 'AK']];
  var BYLEN = Object.keys(NAME).filter(function (k) { return k !== 'DC'; }).sort(function (a, b) { return NAME[b].length - NAME[a].length; });

  function norm(s) {
    return String(s || '').toLowerCase().replace(/&/g, ' and ').replace(/['’`.]/g, '').replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function slug(s) { return norm(s).replace(/ /g, '-'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  // "Bend, OR" / "Bend Oregon" / "Oregon" / "Washington, D.C." → { st: 'OR', rest: 'bend' }
  function splitState(q) {
    var t = norm(q).replace(/\b(usa|us|united states)$/, '').trim();
    if (/(^|\s)(d c|dc)$/.test(t)) return { st: 'DC', rest: t.replace(/(^|\s)(d c|dc)$/, '').replace(/\s*washington$/, '').trim() };
    var m = /(^|\s)([a-z]{2})$/.exec(t);
    if (m && NAME[m[2].toUpperCase()]) return { st: m[2].toUpperCase(), rest: t.slice(0, m.index).trim() };
    for (var i = 0; i < BYLEN.length; i++) {
      var n = norm(NAME[BYLEN[i]]);
      if (t === n || (t.length > n.length && t.slice(-n.length - 1) === ' ' + n)) return { st: BYLEN[i], rest: t.slice(0, t.length - n.length).trim() };
    }
    return { st: '', rest: t };
  }
  function miles(a, b, c, d) {
    var R = 3958.8, r = Math.PI / 180, x = Math.sin((c - a) * r / 2), y = Math.sin((d - b) * r / 2);
    var h = x * x + Math.cos(a * r) * Math.cos(c * r) * y * y;
    return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
  }
  function where(r) { return typeof r.la === 'number' && typeof r.lo === 'number' ? [r.la, r.lo] : null; }
  function mean(list) {
    var a = 0, b = 0, n = 0;
    list.forEach(function (r) { var p = where(r); if (p) { a += p[0]; b += p[1]; n++; } });
    return n ? [a / n, b / n] : null;
  }
  // a typed place → an origin { la, lo, label, exact, st }
  function resolve(q, rows) {
    var t = String(q || '').trim(); if (!t) return null;
    var z = /^(\d{5})(?:-\d{4})?$/.exec(t.replace(/\s+/g, ''));
    if (z) {
      var z5 = z[1], pos = rows.filter(function (r) { return where(r) && /^\d{5}$/.test(String(r.z || '')); });
      var same = pos.filter(function (r) { return String(r.z) === z5; });
      if (!same.length) {
        var area = pos.filter(function (r) { return String(r.z).slice(0, 3) === z5.slice(0, 3); }), best = Infinity;
        area.forEach(function (r) { best = Math.min(best, Math.abs(+r.z - +z5)); });
        same = area.filter(function (r) { return Math.abs(+r.z - +z5) === best; });
      }
      var p = mean(same);
      if (p) return { la: p[0], lo: p[1], label: 'ZIP ' + z5, exact: false, st: same[0].s };
      var n3 = +z5.slice(0, 3), st = '';
      for (var i = 0; i < Z3.length; i++) if (n3 >= Z3[i][0] && n3 <= Z3[i][1]) { st = Z3[i][2]; break; }
      return st && ST[st] ? { la: ST[st][0], lo: ST[st][1], label: NAME[st], exact: false, st: st, only: true } : null;
    }
    var s = splitState(t);
    if (s.rest) {
      var city = rows.filter(function (r) { return norm(r.c) === s.rest && (!s.st || r.s === s.st); });
      var pc = mean(city);
      if (pc) return { la: pc[0], lo: pc[1], label: city[0].c + ', ' + city[0].s, exact: false, st: city[0].s };
      if (city.length && ST[city[0].s]) return { la: ST[city[0].s][0], lo: ST[city[0].s][1], label: NAME[city[0].s], exact: false, st: city[0].s, only: true };
    }
    if (s.st && ST[s.st]) return { la: ST[s.st][0], lo: ST[s.st][1], label: NAME[s.st], exact: false, st: s.st, only: true };
    return null;
  }
  function nearest(rows, la, lo, k, only) {
    k = k || 3;
    if (only) {   // a state on its own: its stores first; a state with fewer than k is topped up with the nearest just outside it
      var inS = nearest(rows.filter(function (r) { return r.s === only; }), la, lo, k);
      if (inS.length >= k) return inS;
      return inS.concat(nearest(rows.filter(function (r) { return r.s !== only; }), la, lo, k - inS.length));
    }
    return rows.map(function (r) { var p = where(r); return { r: r, d: p ? miles(la, lo, p[0], p[1]) : Infinity }; })
      .filter(function (x) { return isFinite(x.d); }).sort(function (a, b) { return a.d - b.d || a.r.n.localeCompare(b.r.n); }).slice(0, k || 3);
  }

  var styled = false;
  function style() {
    if (styled) return; styled = true;
    var css = '.fwf{--f-fg:#15191a;--f-mute:#4a5a57;--f-line:rgba(0,0,0,.14);--f-in:#fff;--f-btn:#15191a;--f-btn-fg:#fff;display:flex;flex-direction:column;gap:9px;font-size:14px;line-height:1.45;color:var(--f-fg)}' +
      '.fwf--dark{--f-fg:#f3efe8;--f-mute:rgba(243,239,232,.66);--f-line:rgba(255,255,255,.2);--f-in:rgba(255,255,255,.06);--f-btn:#f3efe8;--f-btn-fg:#0a0a0b}' +
      '.fwf[hidden],.fwf [hidden]{display:none!important}' +
      '.fwf-count{margin:0;font-size:15px}.fwf-count b{font-weight:600}' +
      '.fwf-open,.fwf-loc,.fwf-go{font:inherit;font-size:13px;letter-spacing:.1em;cursor:pointer;border-radius:20px;padding:9px 16px;min-height:40px;align-self:flex-start}' +
      '.fwf-open,.fwf-loc{background:transparent;color:var(--f-fg);border:1px solid var(--f-line)}.fwf-go{background:var(--f-btn);color:var(--f-btn-fg);border:0}' +
      '.fwf-open:focus-visible,.fwf-loc:focus-visible,.fwf-go:focus-visible,.fwf-all:focus-visible,.fwf-res li:focus-visible{outline:2px solid var(--f-fg);outline-offset:2px}' +
      '.fwf-box{display:flex;flex-direction:column;gap:8px}.fwf-q{display:flex;gap:8px;align-items:flex-end;margin:0}' +
      '.fwf-l{flex:1;display:flex;flex-direction:column;gap:3px;font-size:12px;color:var(--f-mute)}' +
      '.fwf-l input{font:inherit;font-size:16px;color:var(--f-fg);background:var(--f-in);border:1px solid var(--f-line);border-radius:10px;padding:8px 10px;min-height:40px;box-sizing:border-box;width:100%}' +
      '.fwf-msg{margin:0;font-size:13px;color:var(--f-mute)}.fwf-msg:empty{display:none}' +
      '.fwf-res{list-style:none;margin:0;padding:0}.fwf-res:empty{display:none}.fwf-res li{padding:7px 0;border-top:1px solid var(--f-line)}.fwf-res li:first-child{border-top:0}' +
      '.fwf-res b{display:block;font-weight:600}.fwf-res span{color:var(--f-mute);font-size:13px}.fwf-all{font-size:13px;color:var(--f-fg);align-self:flex-start}';
    var el = document.createElement('style'); el.textContent = css; document.head.appendChild(el);
  }

  function mount(el, o) {
    if (!el) return null;
    if (el.__fwf) { el.__fwf.refresh(); return el.__fwf; }
    o = o || {}; style();
    var all = o.all || '/pages/stores';
    el.classList.add('fwf', 'fwf--' + (o.mode || 'light'));
    el.innerHTML = '<p class="fwf-count"></p>' +
      '<button type="button" class="fwf-open">Find the one nearest you</button>' +
      '<div class="fwf-box" hidden><button type="button" class="fwf-loc">Use my location</button>' +
      '<form class="fwf-q" novalidate><label class="fwf-l"><span>Or type a ZIP, or a city and state</span>' +
      '<input name="fwf-place" maxlength="80" autocomplete="postal-code" placeholder="ZIP, or City, ST"></label>' +
      '<button type="submit" class="fwf-go">Find</button></form>' +
      '<p class="fwf-msg" role="status" aria-live="polite"></p><ol class="fwf-res"></ol></div>' +
      '<a class="fwf-all" href="' + esc(all) + '"></a>';
    var countEl = el.querySelector('.fwf-count'), openB = el.querySelector('.fwf-open'), box = el.querySelector('.fwf-box'),
      locB = el.querySelector('.fwf-loc'), form = el.querySelector('.fwf-q'), input = form.querySelector('input'),
      msg = el.querySelector('.fwf-msg'), res = el.querySelector('.fwf-res'), allA = el.querySelector('.fwf-all');
    var rows = function () { try { return (o.rows && o.rows()) || []; } catch (e) { return []; } };
    var last = null;
    function refresh() {
      var r = rows(), states = {};
      r.forEach(function (x) { if (x.s) states[x.s] = 1; });
      var n = r.length, m = Object.keys(states).length;
      el.hidden = !n;
      countEl.innerHTML = 'Fragile What? is in <b>' + n + ' ' + (n === 1 ? 'store' : 'stores') + '</b> in ' + m + ' ' + (m === 1 ? 'state' : 'states') + '.';
      if (!last) { allA.textContent = 'See all ' + n + ' stores'; allA.setAttribute('href', all); }
      el.setAttribute('data-count', n); el.setAttribute('data-states', m);
    }
    function show(origin, mine) {
      var r = rows(), top = nearest(r, origin.la, origin.lo, 3, origin.only ? origin.st : '');
      last = origin;
      msg.textContent = mine ? 'Nearest to you:' : 'Closest to ' + origin.label + ':';
      res.innerHTML = top.map(function (x) {
        var d = x.d < 10 ? Math.max(1, Math.round(x.d)) : Math.round(x.d / 5) * 5;
        // a whole state ("Oregon", or a ZIP known only by its state): no miles — measured from the state's middle they mean nothing
        return '<li tabindex="0" data-si="' + (x.r.si != null ? x.r.si : '') + '"><b>' + esc(x.r.n) + '</b><span>' + esc((x.r.c ? x.r.c + ', ' : '') + x.r.s) +
          (origin.only ? '' : ' · ' + (mine ? '' : 'about ') + d + ' mi') + '</span></li>';
      }).join('');
      if (origin.st) {
        var inSt = r.filter(function (x) { return x.s === origin.st; }).length;
        allA.textContent = inSt ? 'See all ' + inSt + ' ' + (inSt === 1 ? 'store' : 'stores') + ' in ' + NAME[origin.st] : 'See all ' + r.length + ' stores';
        allA.setAttribute('href', inSt ? all + '#' + slug(NAME[origin.st]) : all);
      } else { allA.textContent = 'See all ' + r.length + ' stores'; allA.setAttribute('href', all); }
      Array.prototype.forEach.call(res.children, function (li) {
        var si = li.getAttribute('data-si'); if (si === '' || !o.hot) return;
        var on = function () { o.hot(+si, true); }, off = function () { o.hot(+si, false); };
        li.addEventListener('mouseenter', on); li.addEventListener('mouseleave', off); li.addEventListener('focus', on); li.addEventListener('blur', off);
      });
      return top;
    }
    openB.addEventListener('click', function () { box.hidden = false; openB.hidden = true; locB.focus({ preventScroll: true }); });
    locB.addEventListener('click', function () {
      if (!navigator.geolocation) { msg.textContent = 'This browser can\'t share a location. Type a ZIP or a city and state.'; return; }
      msg.textContent = 'Finding the nearest store…'; res.innerHTML = '';
      navigator.geolocation.getCurrentPosition(function (p) {
        show({ la: p.coords.latitude, lo: p.coords.longitude, label: 'you' }, true);
      }, function () {
        msg.textContent = 'Location is off. Type a ZIP or a city and state instead.'; input.focus({ preventScroll: true });
      }, { timeout: 10000, maximumAge: 600000 });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var origin = resolve(input.value, rows());
      if (!origin) { res.innerHTML = ''; msg.textContent = 'No match. Try a ZIP, or a city and state like Bend, OR.'; return; }
      show(origin, false);
    });
    var api = { refresh: refresh, show: show, resolve: function (q) { return resolve(q, rows()); }, nearest: function (la, lo) { return nearest(rows(), la, lo, 3); } };
    el.__fwf = api;
    refresh();
    return api;
  }
  window.FWFinder = { mount: mount, resolve: resolve, nearest: nearest, miles: miles, slug: slug };
})();
